function UnderMaintenance() {
  return (
    <div
      style={{
        minHeight: 'calc(100vh - 80px)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '40px 24px',
      }}
    >
      <div style={{ textAlign: 'center', maxWidth: 560 }}>
        <div
          style={{
            fontFamily: 'Fragment Mono, monospace',
            fontSize: 12,
            letterSpacing: '0.18em',
            textTransform: 'uppercase',
            color: '#C8873E',
            marginBottom: 24,
          }}
        >
          Royco Risk
        </div>
        <h1
          style={{
            fontFamily: 'Shippori Mincho B1, serif',
            fontSize: 48,
            fontWeight: 500,
            lineHeight: 1.1,
            color: '#111111',
            margin: '0 0 20px',
          }}
        >
          Under Maintenance
        </h1>
        <p
          style={{
            fontFamily: 'Inter, sans-serif',
            fontSize: 16,
            lineHeight: 1.6,
            color: '#555',
            margin: 0,
          }}
        >
          Simulators coming soon, please check back later.
        </p>
      </div>
    </div>
  );
}

export default UnderMaintenance;
